import React, { useState } from 'react'

import LABEL from '../../../business-const/Label/Label'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    TabsPadrao,
    TabPadrao,
} from '../../../business-components/Tab/Tab'

import tabAcompanhamentoFormList from '../../../business-rules/List/tabAcompanhamentoFormList'

import {
    descricaoMenu,
} from '../../../business-components/String/String'

import {
    calculaTotaisSeguroVidaCotacao,
} from '../seguroVidaCotacao-form/SeguroVidaCotacaoService'

import {
    calculaTotaisSeguroVidaProposta,
} from '../seguroVidaProposta-form/SeguroVidaPropostaService'

import {
    calculaTotaisSeguroVida,
} from '../seguroVida-form/SeguroVidaService'

import AcompanhamentoFormFunisEtapas from './AcompanhamentoFormFunisEtapas'

import AcompanhamentoFormPendencias from './AcompanhamentoFormPendencias'

import AcompanhamentoFormAnotacoes from './AcompanhamentoFormAnotacoes'

import AcompanhamentoFormAportes from './AcompanhamentoFormAportes'

import ConsorcioFormConsorcio from '../consorcio-form/ConsorcioFormConsorcio'

import AcompanhamentoFormSeguroVida from './AcompanhamentoFormSeguroVida'

import AcompanhamentoFormArquivo from './AcompanhamentoFormArquivo'



const AcompanhamentoForm = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, handleSubmitAutomatico,
    vars, arquivoList, obterArquivoList }) => {
    
    const [tabIndexAcompanhamento, setTabIndexAcompanhamento] = useState(
        values.tabIndexAcompanhamento >
        tabAcompanhamentoFormList(values.jsonAcessoCliente, values.modoInteracaoCliente, vars.linhaTipoLicenca).length - 1
            ?
                tabAcompanhamentoFormList(values.jsonAcessoCliente, values.modoInteracaoCliente, vars.linhaTipoLicenca).length - 1
            :
                values.tabIndexAcompanhamento
    )

    const handleTabChangeAcompanhamento = (e, value) => {
        values.tabIndexAcompanhamento = value

        setTabIndexAcompanhamento(value)
    }

    calculaTotaisSeguroVidaCotacao(values)
    calculaTotaisSeguroVidaProposta(values)
    calculaTotaisSeguroVida(values)

    return (
        <DivForm>
            <TabsPadrao
                value={tabIndexAcompanhamento}
                onChange={handleTabChangeAcompanhamento}
                level={2}
            >
                {tabAcompanhamentoFormList(values.jsonAcessoCliente, values.modoInteracaoCliente, vars.linhaTipoLicenca)?.map((item, ind) => (
                    <TabPadrao
                        value={ind}
                        label={item}
                        key={ind}
                        level={2}
                    />
                ))}
            </TabsPadrao>
            {descricaoMenu(tabAcompanhamentoFormList(values.jsonAcessoCliente,
            values.modoInteracaoCliente, vars.linhaTipoLicenca)[tabIndexAcompanhamento]) ===
            LABEL.tabAcompanhamentoFormListPendencias && (
                <AcompanhamentoFormPendencias
                    variaveisGlobais={variaveisGlobais}
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                    vars={vars}
                />
            )}
            {descricaoMenu(tabAcompanhamentoFormList(values.jsonAcessoCliente,
            values.modoInteracaoCliente, vars.linhaTipoLicenca)[tabIndexAcompanhamento]) ===
            LABEL.tabAcompanhamentoFormListFunisEtapas && (
                <AcompanhamentoFormFunisEtapas
                    variaveisGlobais={variaveisGlobais}
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                    vars={vars}
                />
            )}
            {descricaoMenu(tabAcompanhamentoFormList(values.jsonAcessoCliente,
            values.modoInteracaoCliente, vars.linhaTipoLicenca)[tabIndexAcompanhamento]) ===
            LABEL.tabAcompanhamentoFormListAnotacoes && (
                <AcompanhamentoFormAnotacoes
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                />
            )}
            {descricaoMenu(tabAcompanhamentoFormList(values.jsonAcessoCliente,
            values.modoInteracaoCliente, vars.linhaTipoLicenca)[tabIndexAcompanhamento]) ===
            LABEL.tabAcompanhamentoFormListAportes && (
                <AcompanhamentoFormAportes
                    variaveisGlobais={variaveisGlobais}
                    valuesClienteNull={values}
                    handleSubmitAutomaticoNull={handleSubmitAutomatico}
                />
            )}
            {descricaoMenu(tabAcompanhamentoFormList(values.jsonAcessoCliente,
            values.modoInteracaoCliente, vars.linhaTipoLicenca)[tabIndexAcompanhamento]) ===
            LABEL.tabAcompanhamentoFormListConsorcio && (
                <ConsorcioFormConsorcio
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                    vars={vars}
                />
            )}
            {descricaoMenu(tabAcompanhamentoFormList(values.jsonAcessoCliente,
            values.modoInteracaoCliente, vars.linhaTipoLicenca)[tabIndexAcompanhamento]) ===
            LABEL.tabAcompanhamentoFormListSeguroVida && (
                <AcompanhamentoFormSeguroVida
                    variaveisGlobais={variaveisGlobais}
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                    vars={vars}
                    popupCotacao={false}
                    popupApolice={false}
                    arquivoList={arquivoList}
                />
            )}
            {descricaoMenu(tabAcompanhamentoFormList(values.jsonAcessoCliente,
            values.modoInteracaoCliente, vars.linhaTipoLicenca)[tabIndexAcompanhamento]) ===
            LABEL.tabAcompanhamentoFormListArquivo && (
                <AcompanhamentoFormArquivo
                    variaveisGlobais={variaveisGlobais}
                    values={values}
                    vars={vars}
                    arquivoList={arquivoList}
                    obterArquivoList={obterArquivoList}
                />
            )}
        </DivForm>
    )
}

export default AcompanhamentoForm